import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { OffboardingManagementPage } from '@/features/offboarding'

export const Route = createFileRoute(
  '/_authenticated/_organization/offboarding/',
)({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: OffboardingRoute,
})

function OffboardingRoute() {
  const navigate = useNavigate()
  const { data: activeMember } = authClient.useActiveMember()
  const memberRole = activeMember?.role

  if (memberRole && memberRole !== 'owner' && memberRole !== 'admin') {
    navigate({ to: '/' })
    return null
  }

  return <OffboardingManagementPage />
}
